module.exports = __webpack_public_path__ + "static/about-us-8c703f02d97f502888c9ada65a75c0d2.png";